import { extInfo } from 'lib/extInfo';
import { stringify } from 'qs';
import { ESearchOptionSource, ESearchOptionType } from 'reactApp/ui/WebSearch/WebSearch.data';

export const SEARCH_PER_PAGE_LIMIT = 500;

export const getExtsBySearchType = (searchType: string) => {
    return extInfo.getExtsByKind(searchType).join(',');
};

export const getSearchQueryString = (
    query: string,
    { searchType, searchSource }: { searchType?: ESearchOptionType; searchSource?: ESearchOptionSource }
) => stringify({ query, searchType, searchSource }, { addQueryPrefix: true });
